import React from 'react'

const SANC = () => {
  return (
    <div>SANC</div>
  )
}

export default SANC